export default __webpack_public_path__ + "static/media/listbuilder-postit-selected.f070be35.svg";